import { Container, Row, Col } from 'react-bootstrap';
import Left from './components/Left';
import Right from './components/Right';
import { Colors } from '../../../../utils/colors/colors';
import { BLOG } from '../../../../routes/index.routes';
import { useState } from 'react';





export default function LatestBlog({
  data
}) {


  const latestBlog = data?.[0];

  const {
    whiteColor
  } = Colors();



  return (
    <>
      <a
        href={`${BLOG}/${latestBlog?.slug}`}
        hrefLang="en-us"
      >

        <section
          className="section blog-section-section"
          id="blog-section"
          style={{
            position: "relative",
            top: "-25vh"
          }}
        >
          <Container>
            <Row
              style={{
                padding: "0",
                margin: "1rem auto"
              }}
            >
              <Col
                xs={{ span: 12, order: 2 }}
                md={{ span: 6, order: 2 }}
                lg={{ span: 6, order: 2 }}
                style={{
                  backgroundColor: whiteColor,
                  padding: "2rem",
                  borderTopRightRadius: "4px",
                  borderBottomRightRadius: "4px",
                  boxShadow: "2px 2px 4px 0 rgba(0, 0, 0, 0.1)",
                  maxHeight: "400px"
                }}
              >
                <Left
                  id={latestBlog?.id}
                  latestBlogId={latestBlog?.id}
                  latestBlogTitle={latestBlog?.blogTitle}
                  latestBlogBody={latestBlog?.blogBody}
                  date={latestBlog?.date}
                  timeToRead={latestBlog?.timeToRead}
                />
              </Col>

              <Col
                xs={{ span: 12, order: 1 }}
                md={{ span: 6, order: 1 }}
                lg={{ span: 6, order: 1 }}
                style={{
                  padding: "0"
                }}
              >
                <Right
                  latestBlogBg={latestBlog?.featuredImage}
                />
              </Col>
            </Row>
          </Container>
        </section>

      </a>
    </>
  )
};




